import { get as getConstants } from '@lumapps/constants';

import { Route } from '../types';

const constants = getConstants();

/**
 * Extract relative Route object from a string URL using new URL().
 * @param url - URL as a string.
 */
export const getRelativeRouteFromUrl = (url: string, appId = constants.applicationId): Route | null => {
    if (!url) {
        return null;
    }

    try {
        const newUrl = new URL(url, window.location.origin);

        return {
            query: newUrl.search,
            anchor: newUrl.hash,
            appId,
            path: newUrl.pathname,
        };
    } catch (e) {
        return null;
    }
};
